export default __webpack_public_path__ + "static/media/Epic_open.c684adad.webm";